export const cilMedicalCross = ["24 24","<path d='M16.125 0.75h-8.25v7.125h-7.125v8.25h7.125v7.125h8.25v-7.125h7.125v-8.25h-7.125zM21.75 9.375v5.25h-7.125v7.125h-5.25v-7.125h-7.125v-5.25h7.125v-7.125h5.25v7.125z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-medical-cross.js
// module id = null
// module chunks = 